<template>
  <v-app-bar
    :clipped-left="false"
    app
    color="primary"
    dark
    dense
    elevation="0"
  >
<!--    <v-app-bar-nav-icon @click.stop="toggleSidebar"></v-app-bar-nav-icon>-->
    <v-toolbar-title class="mr-4">
      <router-link :to="{name: 'dashboard'}" style="cursor: pointer;" tag="span">
        <v-img :src="require('@/assets/nt-no-text.svg')" style="width: 50px;"></v-img>
      </router-link>
    </v-toolbar-title>
    <v-toolbar-items>
      <v-btn icon v-for="link in _links" :key="link.to" :to="link.to"><v-icon>{{link.icon}}</v-icon></v-btn>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-menu bottom offset-y>
      <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-avatar
          color="accent"
          size="36">
          <span class="white--text headline">{{_avatar}}</span>
        </v-avatar>
      </v-btn>
      </template>
      <user-menu/>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import userMenu from 'app/user/components/UserMenu'

export default {
  name: 'navbar',

  components: {
    userMenu
  },
  data () {
    return {
      title: 'НТ'
    }
  },

  computed: {
    ...mapGetters('tradle', {
      _links: 'links',
      _sidebarState: 'sidebarState'
    }),
    ...mapGetters('user', {
      _user: 'user',
      _avatar: 'avatar',
      _showBalance: 'showBalance'
    }),
    editedLinks () {
      if (!this._showBalance) {
        return this._links.filter((link) => link.to !== 'balance')
      } else {
        return this._links
      }
    }
  },

  methods: {
    ...mapActions('tradle', {
      _toggleSidebar: 'toggleSidebar'
    }),
    toggleSidebar () {
      this._toggleSidebar(!this._sidebarState)
    }
  }
}
</script>

<style scoped>

</style>
